import { getToken, removeToken } from "../utils/auth";
import router from "@/router";
import axios from "axios";
import { Message } from "element-ui";

// 创建axios实例
// eslint-disable-next-line no-undef
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 20000 // 请求超时时间
});

// axios 请求拦截器，有token值则配置上token值
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token和Authorization
      config.headers["token"] = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// axios 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
service.interceptors.response.use(
  res => {
    if (res.data.busCode === 0) {
      return res.data;
    } else if (res.data.busCode === -1003) {
      // 记录上次地址
      if (router.currentRoute.fullPath != '/login') {
        localStorage.setItem("lastPath", router.currentRoute.fullPath)
      }
      removeToken();
      router.push("/login");
    } else {
      // eslint-disable-next-line no-undef
      Message({
        showClose: true,
        message: res.data.busMsg,
        type: "error"
      });
      return;
    }
  },
  error => {
    if (error) {
      if (error.message === "Network Error") {
        // eslint-disable-next-line no-undef
        Message({
          message: "无法连接到本地代理程序，请确认代理程序是否运行正常！",
          type: "error",
          duration: 5 * 1000
        });
      } else {
        // eslint-disable-next-line no-undef
        Message({
          message: "请求超时，请稍后再试！",
          type: "error",
          duration: 5 * 1000
        });
      }
      return;
    }
    return;
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/api/request.js